import { Blob } from "expo-blob";

// React Native's core `Blob` (react-native/Libraries/Blob) can't be constructed
// from `ArrayBuffer`/`ArrayBufferView` parts — `new Blob([arrayBuffer])` throws
// "Creating blobs from 'ArrayBuffer' and 'ArrayBufferView' are not supported".
// expo-blob is a web-spec-compliant `Blob` that accepts those parts, so install
// it as the global. Any consumer that builds a blob from binary data (e.g.
// oRPC's streamed-batch decode path) then works on native. Import this once at
// app startup, before anything that touches the global `Blob`.
//
// oxlint-disable-next-line typescript/no-unsafe-type-assertion -- expo-blob's Blob is a spec-compliant superset of the global Blob constructor
globalThis.Blob = Blob as unknown as typeof globalThis.Blob;
